/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

import { ShowBase } from './blackmostros.showbase.js';
import {
  when_available,
  convertToPick,
  convertToHashtag,
  convert_facebook_url,
  parent,
  console_if_debug,
  } from './blackmostros.method.js';

var BlackMostrosTwitter = (function($, _lang){

  var _ready = false,
    _args = {
      link_color: '#2B7BB9',
      href: {
        'fifawwc_es': 'FIFAWWC_ESP?ref_src=twsrc%5Etfw',
        'fifawwc_en': 'FIFAWWC?ref_src=twsrc%5Etfw',
        },
      // message: {
      //   es: {
      //     "Ver el"
      //     },
      //   en: {}
      //   },
      },
    mpublic = {};

  // ~ async function _init(){
  function _init(){
    // load social sdk at first click
    _load_social_sdk();
    // ~ await _load_social_sdk();
    console_if_debug('BlackMostrosTwitter ready...');
    // ~ console.log('BlackMostrosTwitter ready...');
  }
  mpublic.init = _init;
  mpublic.ready = _ready;

  function _set_sdk_events(callback, _stools){
    /**
     * set twitter events
     *
     */
    twttr.ready(function (twttr) {
      twttr.events.bind(
        'loaded',
        callback
        //_try_show_widget
        );
      // twttr.events.bind('rendered', function(element){
      //   // ~ console.log('element:', element, element.parentNode);
      //   element.target.parentNode.classList.add("collapse");
      //   // ~ $(element).addClass("collapse");
      // });
      /**
       * load twitter widgets
       *
       */
      twttr.widgets.load(_stools);
    });
  }
  mpublic.set_sdk_events = _set_sdk_events;

  /**
   * show a timeline in an element
   * need load sdk
   * <a class="twitter-timeline" data-link-color="#2B7BB9" href="https://twitter.com/FIFAWWC_ESP?ref_src=twsrc%5Etfw">Tweets by FIFAWWC_ESP</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script></div>
   *
   */
  function _show_timeline_in(args, element) {
    let _lcolor = args.link_color || _args.link_color,
      _href = _args.href[args.timeline];
    element.innerHTML = `<a class="twitter-timeline" data-link-color="${_lcolor}" href="https://twitter.com/${_href}"></a>`;
  }
  mpublic.show_timeline_in = _show_timeline_in;

  function _get_inner_text(
    sharetext,
    dataurl,
    datahashtags,
    _twitteruserid,
    datarelated,
    hashtagtext
    ){
      let _re =
        '<a class="twitter-share-button" href="https://twitter.com/share"' +
        //~ data-size="large"
        'data-text="' + sharetext + '"' +
        'data-url="' + dataurl + '"' +
        'data-hashtags="' + datahashtags + '"' +
        'data-via="' + _twitteruserid + '"' +
        'data-related="' + datarelated + '">' +
        hashtagtext +
        '</a>';
      return _re
    }
  mpublic.get_inner_text = _get_inner_text;

  /*
   * load  twitter sdk
   * from https://developer.twitter.com/en/docs/twitter-for-websites/javascript-api/guides/set-up-twitter-for-websites
   *
   */
  async function _load_social_sdk() {
    // twitter sdk
    function _start_twttr(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];

      function _ready(f) {
        t._e.push(f);
      }
      t.ready = _ready;

      return t;
    }

    window.twttr = _start_twttr($, "script", "twitter-wjs");

    // Wait for the asynchronous resources to load
    await twttr.ready(function (twttr) {
      // Now bind our custom intent events
      //~ twttr.events.bind('click', clickEventToAnalytics);
      //~ twttr.events.bind('tweet', tweetIntentToAnalytics);
      //~ twttr.events.bind('retweet', retweetIntentToAnalytics);
      //~ twttr.events.bind('like', likeIntentToAnalytics);
      //~ twttr.events.bind('follow', followIntentToAnalytics);
      _ready = true;
    });
    _ready = true;
  }

  return mpublic;

});

var BlackMostrosFacebook = (function($, _lang){

  var _ready = false,
    mpublic = {};

  async function _init(){
    // load social sdk at first click
    await _load_social_sdk();
    console_if_debug('BlackMostrosFacebook ready...');
    // ~ console.log('BlackMostrosFacebook ready...');
  }
  mpublic.init = _init;
  mpublic.ready = _ready;

  function _set_sdk_events(callback){

    /**
     * set facebook events
     *
     */
    //~ $(document).bind('fbInit',function(){
    //~ $(window).ready(function(){
    function _fb_init() {
      //~ console.log('fbInit complete; FB Object is Available');
      FB.Event.subscribe(
        'xfbml.render',
        callback
        // ~ _try_show_widget
        );
      /**
       * load facebook widgets
       *
       */
      FB.XFBML.parse();
    }
    window.fbAsyncInit = _fb_init;

  }
  mpublic.set_sdk_events = _set_sdk_events;

  function _get_inner_text(
    _furl,
    _flwidth,
  ){
    let _re =
    //'<div class="fb-like"></div>' +
    //'<a href="#">facebook</a>' +
    //'<iframe class="fb-send" data-href="' + dataurl +
    //'" data-layout="button"></iframe>' +

    // next dont show logos
    //'<div class="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/" data-layout="button_count" data-size="small" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse">Compartir</a></div>'+
    //'<iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=small&mobile_iframe=true&width=142&height=20&appId" width="142" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe>' +
    //'<div class="fb-like">' +
    //'<span src="https://www.facebook.com/plugins/share_button.php?href=' +
    //'<p>https://www.facebook.com/plugins/share_button.php?href=' + convert_facebook_url(dataurl) + '%2F&layout=button&size=small&mobile_iframe=true&width=142&height=20&appId</p>' +
    '<iframe src="https://www.facebook.com/plugins/like.php?href=' + _furl + '&width=143&layout=button&action=like&size=small&show_faces=true&share=true&height=65&appId" width="' + _flwidth + '" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="false"></iframe>'
    //~ '<iframe src="https://www.facebook.com/plugins/like.php?href=' + _furl + '&width=76&layout=button&action=like&size=small&show_faces=true&share=false&height=65&appId" width="76" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="false"></iframe>' +
    //~ '<iframe src="https://www.facebook.com/plugins/share_button.php?href=' + _furl + '&layout=button&size=small&mobile_iframe=true&width=81&height=20&appId" width="81" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="false"></iframe>' +
    //'<div class="fb-save" data-uri="' + dataurl + '" data-size="small"></div>' +
    //'<iframe src="https://www.facebook.com/plugins/share_button.php?href=http%3A%2F%2Flocalhost%2F~david%2Fpronia%2Fes364%2Fes%2F&layout=button&size=small&mobile_iframe=true&width=81&height=20&appId" width="81" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe>' +
    //+ '%2F&layout=button&size=small&mobile_iframe=true&width=81&height=20&appId" width="81" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true">facebook</span>' +
    //'<iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button&size=small&mobile_iframe=true&width=81&height=20&appId" width="81" height="20" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe>' +
    //'<a href="https://twitter.com/messages/compose?recipient_id=1961141665' +
    // + '" class="twitter-dm-button" data-screen-name="@'+ _twitteruserid +'">Message @'+_twitteruserid+'</a>' +
    //'<a href="https://twitter.com/intent/tweet?button_hashtag=' +
    //hashtagtext +
    //'" class="twitter-hashtag-button" data-show-count="' + showcount +
    //'">#' + hashtagtext + '</a>' +
    // '<a class="twitter-timeline" href="https://twitter.com/TwitterDev/likes">Tweets Liked by @TwitterDev</a>' +
    //'<a class="twitter-share-button" ' +
    //'href="https://twitter.com/intent/tweet?text=' +
    //sharetext + '">Tweet</a></div>' +
    ;
    return _re;

  }
  mpublic.get_inner_text = _get_inner_text;


  /*
   * load facebook sdk
   * from
   *
   */
  async function _load_social_sdk() {
    // facebook sdk
    /*
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v2.8";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    */
    /** only work if is a developer
    window.fbAsyncInit = function() {
      FB.init({
        //appId      : 'your-app-id',
        xfbml      : true,
        version    : 'v2.8'
      });
      FB.AppEvents.logPageView();
    };
    */
    await (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
       js.src = "//connect.facebook.net/" + _lang + "_ES/sdk.js#xfbml=1&version=v2.8";
       fjs.parentNode.insertBefore(js, fjs);
       // ~ _ready = true;
     }($, 'script', 'facebook-jssdk'));
    _ready = true;
  }

  return mpublic;
});

var BlackMostrosGoogleplus = (function($, _lang){

  var _ready = false,
    mpublic = {};

  async function _init(){
    // load social sdk at first click
    await _load_social_sdk();
    console_if_debug('BlackMostrosGoogleplus ready...');
    // ~ console.log('BlackMostrosGoogleplus ready...');
  }
  mpublic.init = _init;
  mpublic.ready = _ready;

  function _set_sdk_events(callback){
    /**
     * set google+ events
     *
     */
    when_available('gapi', function(){
      gapi.plusone.go(); // for +1 in all page
      gapi.plus.go(); // for all page
      //~ gapi.plus.go(_stools); // for performance
      //~ gapi.interactivepost.go();
      callback();
      // ~ _try_show_widget();
    });
  }
  mpublic.set_sdk_events = _set_sdk_events;

  function _get_inner_text(
    _furl,
    _flwidth,
  ){
    let _re =
      // google+ disabled
      '<div><div class="g-plusone" data-size="medium" data-href="' + dataurl + '" data-annotation="none" style="display:inline-block"></div></div>' +
      '<div><div class="g-plus" data-action="share" data-href="' + dataurl + '" data-annotation="none"></div></div>' +
      //~ '<div><button class="g-interactivepost" data-contenturl="https://plus.google.com/pages/" data-contentdeeplinkid="/pages" data-clientid="xxxxx.apps.googleusercontent.com" data-cookiepolicy="single_host_origin" data-prefilltext="Engage your users today, create a Google+ page for your business." data-calltoactionlabel="CREATE" data-calltoactionurl="http://plus.google.com/pages/create" data-calltoactiondeeplinkid="/pages/create">Tell your friends</button></div>' +

      '';
      return _re;
  }
  mpublic.get_inner_text = _get_inner_text;


  /*
   * load google+ sdk
   * from
   *
   */
  async function _load_social_sdk() {
    // google+ sdk
    // google+ sdk
    window.___gcfg = {lang: _lang, parsetag: 'explicit'};

    await (function() {
      var po = $.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.src = 'https://apis.google.com/js/platform.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
      _ready = true;
    })();

  }

  return mpublic;
});

var BlackMostrosSocial = (function($){
  /**
   *
   * share article in social networks
   *
   */

  var _sb = new ShowBase(),
    _articleid,
    _articles,
    _headerid,
    _headers,
    _stools,
    _moshared = false,
    _timeline_element,
    _cwidth,
    _sharewidth = 100,
    _twitteruserid,
    _lastclicked = 0,
    _dataurl,
    _twitter,
    _facebook,
    // ~ _gplus,
    _hidden_class = 'hidden',
    _maxwidgets = 4, // maximun social widgets to show
    _lsdk = false,
    _acache = {},  // article cache
    _astack = {},  // article stack
    _panel_widget_tags = ['a', 'iframe'],
    _widgetsloaded = false,
    _dom_elements = [
      'dd.modified',
      'div.contenedor',
      // ~ 'div.g0',
      ],
    _ids = {
      timeline: [
        'fifawwc_es',
        'fifawwc_en',
        ],
      },
    _css = {
      hide: 'collapse',  // is in article content
      },
    _timelines,
    _lang = $.documentElement.lang.split('-')[0],
    mpublic = {};

  /**
   * search ids.timeline in dom and add to result
   *
   *
   */
  function _get_timeline_elements(){
    var result = [];
    for (var _id of _ids.timeline) {
      // ~ console_if_debug('id:', _id);
      result.push($.getElementById(_id));
    }
    return result;
  }

  function _set_timeline_elements(){
    _timelines = _get_timeline_elements();
    // set events
    if (_timelines) {
      [].forEach.call(_timelines, function(_timeline) {
          if (_timeline) {
            _timeline.addEventListener('click', _timeline_handler);
          }
        });
    }
    console_if_debug('timelines:', _timelines);
  }

  async function _timeline_handler(evt){
    /**
     * we need load sdk at first click
     * if target differ from _lastclicked, close last and
     * create new one
     * if target is same to _lastclicked, close panel
     **/
    var _pn = evt.target;

    if (_lsdk === false) {
      await _load_social_sdk();
      _lsdk = true;
      };

    if (_timeline_element == undefined) {
      if (_twitter) {
        _timeline_element = evt.target.nextSibling;
        _twitter.show_timeline_in({
          timeline:evt.target.id
          },
          _timeline_element
          );
        };
    }

    if (_timeline_element) {
      _timeline_element.classList.toggle(_css.hide);
    };

  }

  function _init(twitteruserid, articleid, headerid){
    _twitteruserid = twitteruserid,
    _articleid = articleid;
    _headerid = headerid;

    // set all articles
    _articles = $.getElementsByTagName(_articleid);

    // ~ _article = $(_articleid);
    _headers = [];
    [].forEach.call(_articles, function(_article) {

      [].forEach.call(_headerid, function(e) {
        // ~ console.log(e);
        let _e = _article.querySelector(e);
        // ~ _e = _article.find(e);
        _headers.push(_e);
        // react on mouse over event
        if (_e){
          _e.addEventListener('click', _mouseover_handler);
        }
        // ~ _e.on('click', _mouseover_handler);
        // react on mouse leave event
        //~ _e.on('mouseleave', _mouseleave_handler);
      });

    });
    //~ console.log(_headers);

    when_available('_bms', function(){
      // set all twitter timelines
      _set_timeline_elements();

      console_if_debug('timelines:', _timelines, _ids.timeline);
      });

    // load social sdk at first click
    console_if_debug('BlackMostrosSocial ready...');
    // ~ console.log('BlackMostrosSocial ready...');
  }
  mpublic.init = _init;

  function _get_widgets_loaded(){
    return _widgetsloaded;
  }


  function _show_social_loader(panel) {
    /*
     * this loader use css styles
     */
    _stools = $.createElement('div');
    _stools.classList.add('shared_tools');
    _stools.innerHTML = '<div class="loader"></div>';
    panel.append(_stools);

    /*
    _stooll = $(
      '<div class="shared_tools">' +
      '<div class="loader"></div></div>'
      );
      */

  }

  async function _load_social_sdk() {
    // twitter
    _twitter = BlackMostrosTwitter($, _lang);
    await _twitter.init();

    // facebook sdk
    _facebook = BlackMostrosFacebook($, _lang);
    await _facebook.init();

    // google+ sdk
    // _gplus = BlackMostrosGoogleplus($, _lang);
    // await _gplus.init();

    // console.log(
    //   _twitter.ready,
    //   _facebook.ready,
    //   // ~ _gplus.ready,
    //   );

  }

  function _mouseover_shared_handler(evt){
    _moshared = true;
  }

  function _mouseleave_shared_handler(evt){
    _moshared = false;
    //~ _mouseleave_handler(evt);
  }

  function _add_panel_to_dom(
    _dome, _stools
    //_pn, _stools, _ptype, _psp
    ) {
    /**
     * add panel to dom for show
     *
     */
    _dome.appendChild(_stools);
    // ~ _dome.parentElement.insertBefore(_stools, _dome.nextSibling);

    // //~ console.log('addpanel:', _widgetsloaded);
    // //~ when_equal(_widgetsloaded, true, function(){
    // // ~ if (_ptype.length === 0) {
    // // ~ console.log('stools:', _pn, _stools, _ptype, _psp);
    // if (_ptype === null) {
    //   _pn.append(_stools);
    // } else {
    //   // ~ console.log(_psp, _stools, _pn, _ptype);
    //   // ~ _psp.insertAfter()
    //   _psp.parentElement.insertBefore(_stools, _psp.nextSibling);
    //   // ~ _psp.insertBefore(_stools, _psp.nextSibling);
    //   // ~ _stools.parentNode.insertBefore(_psp, _stools.nextSibling);
    //   // ~ _stools.insertAfter(_psp);
    // }
    // //~ });
  }

  function _remove_shared_panel(
    _dome, _stools
    ){
    /**
     * removing from dom
     *
     */
    console_if_debug('remove:', _dome, _stools);
    // ~ console.log('remove:', _dome, _stools);
    _dome.removeChild(_stools);
    // ~ _stools.parentElement.removeChild(_stools);
    // ~ _stools.detach();
    _stools = undefined;
    //~ console.log(_stools);
    //~ _pn = $(evt.target);
    //~ _pn.css({width: _cwidth});

  }

  async function _mouseover_handler(evt){
    /**
     * we need load sdk at first click
     * if target differ from _lastclicked, close last and
     * create new one
     * if target is same to _lastclicked, close panel
     **/
    // ~ console.log(evt.target);
    var _pn = evt.target;
    // ~ var _pn = $(evt.target); //.parentNode;
    if (_lsdk === false) {
      // ~ _show_social_loader(_pn);
      await _load_social_sdk();
      // ~ _remove_shared_panel();
      _lsdk = true;
      }

    /**
     * if stools panel is undefined, create a new one
     *
     *
     */
    if (_lsdk) {
      _do_social_panel(evt);
      // if (_stools === undefined){
      //   _do_social_panel(evt);
      // }
      // else {
      //   _remove_social_panel(evt);
      // };
    }
  }

  // //~ console.log(_stools);
  // if (_stools != undefined) {
  function _remove_social_panel(evt){

    var _removemethod = 0;
    function _close_shared_tools(){

      if (_removemethod == 0) {
        _remove_shared_panel();
      } else {
      /**
       * collapse in dom
       *
       */
        _stools.addClass('collapse');
      }
    }
    //~ console.log(_lastclicked, _pn, _lastclicked == _pn);

    _close_shared_tools();
    _mouseover_handler(evt);
    // //~ if (_lastclicked === _pn) {
    // if (_lastclicked === undefined) {
    //   //~ _lastclicked = _pn;
    //   //~ _mouseleave_shared_handler(evt);
    //   _mouseover_handler(evt);
    //   //~ console.log(_lastclicked, _pn, _lastclicked == _pn);
    // } else {
    //   //~ _lastclicked = _pn;
    //   _mouseover_handler(evt);
    // }
  }

  //  } else {

  function _get_article_link(dome){
    /**
     * find article link to add to articles cache
     * find event target tagname and class for select link type, (full article, or tips table)
     *
     */
    // ~ var _pn = evt.target;
    var _article = parent(dome, 'article'),
      _re, _tag, _parent, _atype;
    // ~ console.log('parent:', dome, _article);

    if (_article) {
      // ~ console.log('parent:', dome, _article);

      // search link
      // ~ var _article = _pn.parents('article');
      var _head = _article.querySelector('h2 a');
      // ~ var _head = _article.find('h2 a');

      // search article type
      // if atype is undefined see if element is:
      // dd.modified or div.g0
      let _t, _c;
      [].forEach.call(_dom_elements, function(_e){
        _t = _e.split('.')[0];
        _c = _e.split('.')[1]; // .slice(1).join('.');
        if (_atype == undefined) {
          if (dome.tagName.toLowerCase() == _t && dome.classList.contains(_c)) _atype = [_e, dome];  // article info
        }
        if (_atype == undefined) {
          _parent = parent(dome, _e);
          if (_parent) {
            _atype = [_e, _parent];
          }
        }
      });

      _tag = _head.href + '/' + _atype[0];
      _re = {
        [_tag]: {
          'head': _head,
          'type': _atype[1],
          'article': _article,
          }
        };
    }

    console_if_debug('alink:', _re);
    // ~ console.log('alink:', _re);

    return _re;
  }


  function _do_social_panel(evt){
    /**
     * find article title, link, keywords,
     * and calculate hashtag
     *
     * if event target have g0 parent, share all picks
     * if event target have g7 parent, share one pick
     *
     * we need set parent for shared buttons panel
     *
     * save dataurl and dom element to article stack,
     * for dont ask again to social sdk
     *
     **/
    var _dome = evt.target;

    var _link = _get_article_link(_dome);

    /**
     * search link in articles cache
     *
     *
     */
    // ~ console.log('acache', _acache, _link, _dome);
    // ~ console.log('keys', Object.keys(_acache), Object.keys(_link), _dome);
    if (_link != undefined){
      // ~ if (Object.keys(_link)[0] in _acache) {
      if (_acache[Object.keys(_link)]) {
        // use cache article to show/hide
        _show_hide_cache_article(_link);
      } else {
        // create a new social article and add to cache
        _show_hide_article(evt, _link);
        // show article
        _show_hide_cache_article(_link);
      }
    }
  }


  // use cache article to show/hide
  function _show_hide_cache_article(_link) {
    /**
     * search social article in cache
     * show or hide and add to cache
     * add url to article stack
     *
     * when create first time, need show article
     *
     * if cache has showing article, hide them
     *
     */
    let _article = _acache[Object.keys(_link)],
      _show = _article.show,
      _dome = _article.data.type,
      _stools = _article.html;
    // ~ try {
    // ~ } catch (e) {
      // ~ console.log('link to show:', _link, _acache);
    // ~ }

    if (_show == true) {
      // hide social tools
      _article.show = false;
      console_if_debug('show:', _acache[Object.keys(_link)].show);
      // ~ console.log('show:', _acache[Object.keys(_link)].show);
      // ~ _link[1]
      // ~ _psp.parentElement.insertBefore(_stools, _psp.nextSibling);
      _remove_shared_panel(_dome, _stools)
      // ~ _article[1] = !_article[1];

    } else {
      // show social tools
      _article.show = true;
      console_if_debug('show:', _acache[Object.keys(_link)].show);
      // ~ console.log('show:', _acache[Object.keys(_link)].show);

      // search in cache for showing tools
      [].forEach.call(_acache, function(_e){
        if (_e.show){
          _e.show = false;
          _remove_shared_panel(_dome, _stools);
        }
      });
      _add_panel_to_dom(_dome, _stools);

      // _link[1]
      // _psp.parentElement.insertBefore(
      //   _article[0],
      //   _psp.nextSibling
      //   );

    }

  }

  function _show_hide_article(evt, _link){
    /**
     * create a new social article
     * show or hide and add to cache
     * add url to article stack
     *
     * when create first time, need show article
     *
     */

    let _show = false,
      _key = Object.keys(_link),
      _dome = _link[_key].type,
      _article = _link[_key].article,
      _stools;

    var _pn = _link[1];

    // load data from article
    _stools = _load_data_from_article(_link);

    // show shared tools
    _add_panel_to_dom(_dome, _stools);

    // var _psp = _pn,
    //   _met = _psp.append,
    //   _clicked = 0;

    // add to cache
    _acache[_key] = {
      'html': _stools,
      'show': _show,
      'data': _link[_key],
      };

    // ~ console.log('link+cache+keys:', _link, _acache, Object.keys(_acache));

  }

  function _load_data_from_article(_link) {
    let _show = true,
      _key = Object.keys(_link),
      _dome = _link[_key].type,
      _head = _link[_key].head,
      _article = _link[_key].article,
      _ptype = `${_dome.tagName.toLowerCase()}.${_dome.classList}`;

    let sharetext = '';
    // ~ var _article = parent(_pn, 'article');

    if (_article) {
      // ~ console.log('parent:', _pn, _psp, _article);
      // ~ var _article = _pn.parents('article');
      // ~ var _head = _article.querySelector('h2 a');
      // ~ var _head = _article.find('h2 a');
      var _loc = window.location;
      var dataurl = _loc.protocol + '//' + _loc.hostname + _head.href;
      // ~ var dataurl = _loc.protocol + '//' + _loc.hostname + _head.attr('href');
      // search url in article stack
      //~ console.log(dataurl, ' in stack...', _astack);

      /**
       * search clicked element type
       *
       */
      // if (_dataurl != dataurl) {
      //   _clicked += 1;
      //   _dataurl == dataurl;
      //   }

      // // ~ console.log('panel:', _pn, _article, _article.closest('.g0'));
      // var _ptype = _pn.closest('.g0');
      // // ~ var _ptype = _pn.closest('.g0');
      // // ~ if (_ptype.length > 0) {
      // if (_ptype) {
      //     _clicked += 1;
      // } else {
      //   /**
      //    * publish pick
      //    * get current pick
      //    **/
      //   _ptype = _pn.closest('.g7');
      //   // ~ _ptype = _pn.parents('.g7');
      //   // ~ if (_ptype.length > 0) {
      //   if (_ptype) {
      //     _clicked += 2;
      //   }
      // }
    }


    //~ var _ptype = _pn.parents('.g0');
    //~ var _ptype = _pn.closest('.g0');
    // ~ if (_ptype.length > 0) {
    if (_ptype == _dom_elements[1]) {
      sharetext += _get_picks_table_data(_dome);

      sharetext += '\n---\n️️';
      // dont show to anonymous user
      // sharetext = 'Te muestro X de ' + _count + ' pronósticos. ';
      sharetext = 'Visítanos para ver el resto.' +
        '\n---' + sharetext;
      // ~ _psp = _ptype;
    }

    sharetext = _head.text.trim() + ' ' + dataurl + '\n' + sharetext;
    // ~ sharetext = _head.text().trim() + ' ' + dataurl + '\n' + sharetext;

    //~ console.log(_lastclicked, _clicked);
    // ~ if (_lastclicked != _clicked) {

    /**
     * get metadata article
     *
     */
    var _meta = _article.querySelector('.article-meta');
    // ~ var _meta = _article.find('.article-meta');

    //~ var _head = _pn.parent().parent().find('h2 a');
    //~ var _meta = _pn.parent().parent().find('.article-meta');
    var datarelated = _meta.querySelector("[itemprop='keywords']").innerText.trim();
    // ~ var datarelated = _meta.find("[itemprop='keywords']").text().trim();
    var hashtagtext = 'Pronia' + convertToHashtag(datarelated.split(',')[0]);
    //~ var hashtagtext = 'Pronia' + convertToSlug(_pn.text());
    var datahashtags = hashtagtext + ',' + datarelated; // + _meta.text();
    var showcount = 'false';

    // or facebook:
    //   - we need convert url format
    //   - we need set widget width
    var _furl = convert_facebook_url(dataurl);
    var _flwidth = {
      es: 156,
      en: 97,
      };

    // make social panel tools
    _stools = $.createElement('div');
    _stools.classList.add('shared_tools');
      // ~ '<div class="shared_tools">' +
    _stools.innerHTML =
      '<div>' + _twitter.get_inner_text(
        sharetext,
        dataurl,
        datahashtags,
        _twitteruserid,
        datarelated,
        hashtagtext,
      ) + '</div><div>' +
      _facebook.get_inner_text(
        _furl,
        _flwidth[_lang],
      ) + '</div>';
      // +
      // _gplus.get_inner_text();
      // ~ );

    // add events to new social panel
    // ~ _stools.addEventListener('mouseover', _mouseover_shared_handler);
    // ~ _stools.addEventListener('mouseleave', _mouseleave_shared_handler);
    // ~ _stools.on('mouseover', _mouseover_shared_handler);
    // ~ _stools.on('mouseleave', _mouseleave_shared_handler);

  return _stools;
  //
  //  var _cwid = 0;
  //
  //  /**
  //   * set social event widgets
  //   * only first time
  //   *
  //   */
  //  _twitter.set_sdk_events(_try_show_widget, _stools);
  //  _facebook.set_sdk_events(_try_show_widget);
  //
  //  _do_when_sdks_ready();
  //
  //  // ~ _lastclicked = _clicked;
  //  // } else {
  //  //   _lastclicked = 0;
  //  // }


    // /**
    //  * show dom in article stack or build new one
    //  *
    //  */
    // // ~ console.log('astack', _astack);
    // if (!([dataurl, _clicked] in _astack)) {
    //
    //   //~ var _ptype = _pn.parents('.g0');
    //   //~ var _ptype = _pn.closest('.g0');
    //   // ~ if (_ptype.length > 0) {
    //   if (_ptype) {
    //     /**
    //      * publish table
    //      * get all picks in table
    //      *
    //      * set shared panel parent
    //      * we need add after
    //      *
    //      **/
    //     // ~ console.log('ptype', _ptype);
    //     var _picks = _ptype.parentElement.querySelectorAll('.g7'),
    //     // ~ var _picks = _ptype.parent().find('.g7'),
    //       _count = 0;
    //     // ~ console.log('this:', this);
    //
    //     [].forEach.call(_picks, function(_pick){
    //
    //       sharetext += convertToPick(
    //         _pick.innerText,
    //         // ~ 'text?',
    //         // ~ $(this).text(),
    //         '\n'
    //         );
    //       _count += 1;
    //
    //       });
    //
    //     // _picks.each(function(){
    //     //   sharetext += convertToPick(
    //     //     $(this).text(),
    //     //     '\n'
    //     //     );
    //     //   _count += 1;
    //     //   });
    //
    //     sharetext += '\n---\n️️';
    //     // dont show to anonymous user
    //     // sharetext = 'Te muestro X de ' + _count + ' pronósticos. ';
    //     sharetext = 'Visítanos para ver el resto.' +
    //       '\n---' + sharetext;
    //     _psp = _ptype;
    //     //~ console.log(_psp[0], $(_psp[0]).insertAfter);
    //     //~ _met = $(_psp[0]).insertAfter;
    //     //~ _clicked += 1;
    //   }/* else {
    //     // to implement a pick element in table
    //   }*/
    //   sharetext = _head.text.trim() + ' ' + dataurl + '\n' + sharetext;
    //   // ~ sharetext = _head.text().trim() + ' ' + dataurl + '\n' + sharetext;
    //
    //   //~ console.log(_lastclicked, _clicked);
    //   if (_lastclicked != _clicked) {
    //     var _meta = _article.querySelector('.article-meta');
    //     // ~ var _meta = _article.find('.article-meta');
    //
    //     //~ var _head = _pn.parent().parent().find('h2 a');
    //     //~ var _meta = _pn.parent().parent().find('.article-meta');
    //     var datarelated = _meta.querySelector("[itemprop='keywords']").innerText.trim();
    //     // ~ var datarelated = _meta.find("[itemprop='keywords']").text().trim();
    //     var hashtagtext = 'Pronia' + convertToHashtag(datarelated.split(',')[0]);
    //     //~ var hashtagtext = 'Pronia' + convertToSlug(_pn.text());
    //     var datahashtags = hashtagtext + ',' + datarelated; // + _meta.text();
    //     var showcount = 'false';
    //     // or facebook:
    //     //   - we need convert url format
    //     //   - we need set widget width
    //     var _furl = convert_facebook_url(dataurl);
    //     var _flwidth = {
    //       es: 156,
    //       en: 97,
    //       };
    //
    //     //~ _cwidth = _pn.css('width');
    //     //~ _pn.css({width: _cwidth + _sharewidth});
    //     //~ $(evt.target).wrapInner( "<div class='date'></div>");
    //     /*
    //     _tweetere = $('<div class="tweeter-shared"></div>');
    //     twttr.widgets.createShareButton(
    //       "https:\/\/www.pronia.es\/es",
    //       _tweetere,
    //       {
    //         //~ size: "large",
    //         text: "custom share text",
    //         hashtags: hashtagtext,
    //         via: "me",
    //         related: "pronia.es,twitter"
    //       }
    //     );
    //     */
    //
    //     //~ var _pb = '<div class="progress progress-striped active"><div class="bar" style="width:100%;height:5px;"></div></div>';
    //     //~ var _pb = '<div class="progress progress-striped active"><div class="progress-bar"  role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%;height:5px;"></div></div>';
    //     // ~ _stools = $(
    //     _stools = $.createElement('div');
    //     _stools.classList.add('shared_tools');
    //       // ~ '<div class="shared_tools">' +
    //     _stools.innerHTML =
    //       '<div>' + _twitter.get_inner_text(
    //         sharetext,
    //         dataurl,
    //         datahashtags,
    //         _twitteruserid,
    //         datarelated,
    //         hashtagtext,
    //       ) + '</div><div>' +
    //       _facebook.get_inner_text(
    //         _furl,
    //         _flwidth[_lang],
    //       ) + '</div>';
    //       // +
    //       // _gplus.get_inner_text();
    //       // ~ );
    //     _stools.addEventListener('mouseover', _mouseover_shared_handler);
    //     _stools.addEventListener('mouseleave', _mouseleave_shared_handler);
    //     // ~ _stools.on('mouseover', _mouseover_shared_handler);
    //     // ~ _stools.on('mouseleave', _mouseleave_shared_handler);
    //
    //     function _do_when_sdks_ready(){
    //       /**
    //        * only do next if social object is ready
    //        * hide widgets and panel by default in shared panel tools
    //        *
    //        */
    //       //~ console.log(_stools.find('a'));
    //       // ~ _panel_widget_tags.forEach(
    //       [].forEach.call(_panel_widget_tags, function(e){
    //
    //         [].forEach.call(
    //           _stools.querySelector(e),
    //           function(t){
    //             t.parentElement.clasList.toggle(_hidden_class)
    //             // ~ console.log('this:', this, t);
    //             // ~ $(this).addClass("collapse");
    //           });
    //
    //         // _stools.find(
    //         //   e
    //         //   //'a'
    //         //   ).each(function(){$(this).addClass("collapse")});
    //
    //       });
    //       // ~ _stools.style.display = 'collapse';
    //       // _stools.css({
    //       //   display:'collapse',
    //       //   // height: 0
    //       //   });
    //
    //       _add_panel_to_dom(_pn, _stools, _ptype, _psp);
    //       //~ console.log(_lastclicked, _pn, _lastclicked === _pn);
    //
    //       /**
    //        * add url to article stack
    //        *
    //        */
    //       _astack[[dataurl, _clicked]] = [
    //         _pn, _stools, _ptype, _psp,
    //         ];
    //
    //     }
    //
    //     var _cwid = 0;
    //
    //     function _try_show_widget(
    //       //event
    //       ){
    //       _cwid += 1;
    //       //~ console.log(_cwid, _maxwidgets);
    //       //~ if (_cwid == _maxwidgets) {
    //         //~ console.log('loaded widget...');
    //         //~ _stools.find('a').css({display:'inherit',});
    //         //~ _stools.find('a').each(function(){$(this).css({display:'inherit',})});
    //
    //         [].forEach.call(
    //           _panel_widget_tags,
    //           function(e){
    //             [].forEach.call(
    //               _stools.querySelectorAll(e),
    //               function(_e){
    //                 // ~ console.log('this', this, _e);
    //                 _e.parentElement.classList.toggle(_hidden_class);
    //               });
    //           });
    //
    //         /*
    //         _panel_widget_tags.forEach(function(e){
    //           _stools.querySelector(e).each(function(){
    //             console.log('this', this);
    //             });
    //
    //           // _stools.find(
    //           //   e
    //           //   //'a'
    //           //   ).each(function(){$(this).removeClass("collapse")});
    //
    //         });
    //         */
    //         //_stools.find('a').each(function(){$(this).removeClass("collapse")});
    //
    //         _stools.style.display = 'inherit';
    //         // _stools.css({
    //         //   display:'inherit',
    //         //   //height: 'auto'
    //         //   });
    //
    //       //~ }
    //       if (_cwid >= _maxwidgets) {
    //         _widgetsloaded = true;
    //         //~ console.log(_cwid, _maxwidgets, _widgetsloaded);
    //       }
    //     }
    //     //~ function _try_show_widget2(event){
    //       //~ console.log('facebook...');
    //       //~ }
    //
    //     // set social event widgets
    //     _twitter.set_sdk_events(_try_show_widget, _stools);
    //     _facebook.set_sdk_events(_try_show_widget);
    //     // dont work
    //     //~ when_equal(_get_widgets_loaded(), true, _do_when_sdks_ready);
    //     _do_when_sdks_ready();
    //
    //     _lastclicked = _clicked;
    //
    //   } else {
    //     _lastclicked = 0;
    //   }
    // } else {
    //     if (_lastclicked != _clicked) {
    //       _stools = _astack[[dataurl, _clicked]][1],
    //       _add_panel_to_dom(
    //         _astack[[dataurl, _clicked]][0],
    //         _stools,
    //         _astack[[dataurl, _clicked]][2],
    //         _astack[[dataurl, _clicked]][3]
    //         );
    //       _lastclicked = _clicked;
    //     } else {
    //       _lastclicked = 0;
    //     }
    //     //~ console.log(dataurl, ' in stack...');
    //   }
  }

  function _try_show_widget(
    //event
    ){
    _cwid += 1;
    //~ console.log(_cwid, _maxwidgets);
    //~ if (_cwid == _maxwidgets) {
      //~ console.log('loaded widget...');
      //~ _stools.find('a').css({display:'inherit',});
      //~ _stools.find('a').each(function(){$(this).css({display:'inherit',})});

      [].forEach.call(
        _panel_widget_tags,
        function(e){
          [].forEach.call(
            _stools.querySelectorAll(e),
            function(_e){
              // ~ console.log('this', this, _e);
              _e.parentElement.classList.toggle(_hidden_class);
            });
        });

      /*
      _panel_widget_tags.forEach(function(e){
        _stools.querySelector(e).each(function(){
          console.log('this', this);
          });

        // _stools.find(
        //   e
        //   //'a'
        //   ).each(function(){$(this).removeClass("collapse")});

      });
      */
      //_stools.find('a').each(function(){$(this).removeClass("collapse")});

      _stools.style.display = 'inherit';
      // _stools.css({
      //   display:'inherit',
      //   //height: 'auto'
      //   });

    //~ }
    if (_cwid >= _maxwidgets) {
      _widgetsloaded = true;
      //~ console.log(_cwid, _maxwidgets, _widgetsloaded);
    }
  }
  //~ function _try_show_widget2(event){
    //~ console.log('facebook...');
    //~ }


  function _do_when_sdks_ready(){
    /**
     * only do next if social object is ready
     * hide widgets and panel by default in shared panel tools
     *
     */
    //~ console.log(_stools.find('a'));
    // ~ _panel_widget_tags.forEach(
    [].forEach.call(_panel_widget_tags, function(e){

      [].forEach.call(
        _stools.querySelector(e),
        function(t){
          t.parentElement.clasList.toggle(_hidden_class)
          // ~ console.log('this:', this, t);
          // ~ $(this).addClass("collapse");
        });

      // _stools.find(
      //   e
      //   //'a'
      //   ).each(function(){$(this).addClass("collapse")});

    });
    // ~ _stools.style.display = 'collapse';
    // _stools.css({
    //   display:'collapse',
    //   // height: 0
    //   });

    _add_panel_to_dom(_pn, _stools, _ptype, _psp);
    //~ console.log(_lastclicked, _pn, _lastclicked === _pn);

    // /**
    //  * add url to article stack
    //  *
    //  */
    // _astack[[dataurl, _clicked]] = [
    //   _pn, _stools, _ptype, _psp,
    //   ];

  }


  function _get_picks_table_data(_dome){
    /**
     * publish table
     * get all picks in table
     *
     * set shared panel parent
     * we need add after
     *
     **/

    let _re = '';
    console_if_debug('dome:', _dome);
    // ~ console.log('dome:', _dome);
    var _picks = _dome.parentElement.querySelectorAll('.g7'),
      // ~ var _picks = _ptype.parent().find('.g7'),
      _count = 0;

    [].forEach.call(_picks, function(_pick){

      _re += convertToPick(
        _pick.innerText,
        // ~ 'text?',
        // ~ $(this).text(),
        '\n'
        );

    });

    return _re;

  }

  // ~ }

  // not used
  // function _mouseleave_handler(
  //   //evt
  //   ){
  //   /**
  //    *
  //    * remove all shared tools
  //    *
  //    */
  //   if (_moshared === false && _stools != undefined) {
  //     //~ _stools.remove();
  //     _stools.detach();
  //     _stools = undefined;
  //     //~ console.log(_stools);
  //     //~ _pn = $(evt.target);
  //     //~ _pn.css({width: _cwidth});
  //   }
  // }

  return mpublic;

});

export {
  BlackMostrosSocial,
  };
